import { render, staticRenderFns } from "./UiBaseIcon.vue?vue&type=template&id=6867aa53&scoped=true&"
import script from "./UiBaseIcon.vue?vue&type=script&lang=js&"
export * from "./UiBaseIcon.vue?vue&type=script&lang=js&"
import style0 from "./UiBaseIcon.vue?vue&type=style&index=0&id=6867aa53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6867aa53",
  null
  
)

export default component.exports